/* MASK SANTA FE - scroll entrance motion + hero slide-in */
(function () {
  'use strict';
  if (window.__mskMotionInit) return;
  window.__mskMotionInit = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduced.matches) return;
  if (!('IntersectionObserver' in window)) return;

  var SELECTORS = [
    '.grid__item',
    '.collection-grid-item',
    '.section-header',
    '.hero__text-content',
    '.background-media-text__inner',
    '.article-listing article',
    '.list-collections__item'
  ].join(',');

  var css =
    'html.msk-motion-on .msk-motion-pre{opacity:0;transform:translateY(18px) scale(.99);}' +
    'html.msk-motion-on .msk-motion-in{opacity:1;transform:translateY(0) scale(1);' +
      'transition:opacity .55s cubic-bezier(.25,.9,.35,1),transform .65s cubic-bezier(.25,1.28,.4,1);' +
      'transition-delay:var(--msk-d,0ms);}' +
    '.msk-hero-pre-l{opacity:0;transform:translateX(-80px);}' +
    '.msk-hero-pre-r{opacity:0;transform:translateX(80px);}' +
    '.msk-hero-in{opacity:1 !important;transform:translateX(0) !important;' +
      'transition:opacity .75s cubic-bezier(.25,.9,.35,1),transform .9s cubic-bezier(.22,1.2,.36,1);' +
      'transition-delay:var(--msk-hd,0ms);}' +
    '@media(prefers-reduced-motion:reduce){' +
      'html.msk-motion-on .msk-motion-pre,.msk-hero-pre-l,.msk-hero-pre-r{opacity:1;transform:none;}}';

  var style = document.createElement('style');
  style.id = 'msk-motion-css';
  style.textContent = css;
  document.head.appendChild(style);
  document.documentElement.classList.add('msk-motion-on');

  /* scroll entrance observer */
  var io = new IntersectionObserver(function (entries) {
    var batch = 0;
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      io.unobserve(el);
      var delay = Math.min(batch * 60, 360);
      batch++;
      el.style.setProperty('--msk-d', delay + 'ms');
      el.classList.add('msk-motion-in');
      setTimeout(function () {
        el.classList.remove('msk-motion-pre', 'msk-motion-in');
        el.style.removeProperty('--msk-d');
      }, 1300 + delay);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  function prep(root) {
    if (!root || !root.querySelectorAll) return;
    var nodes = root.querySelectorAll(SELECTORS);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.getAttribute('data-msk-m')) continue;
      el.setAttribute('data-msk-m', '1');
      if (el.parentElement && el.parentElement.closest('[data-msk-m]')) continue;
      var r = el.getBoundingClientRect();
      if (r.bottom < 0) continue;
      el.classList.add('msk-motion-pre');
      io.observe(el);
    }
  }

  /* hero slide-in */
  /* three enabled hero block IDs, left/right/left pattern */
  var HERO_BLOCKS = [
    { id: 'ai_gen_block_a7357b1_gxcAYB', dir: 'l', delay: 0   },
    { id: 'ai_gen_block_a7357b1_X6ADM6', dir: 'r', delay: 140 },
    { id: 'ai_gen_block_a7357b1_KAygwk', dir: 'l', delay: 280 }
  ];

  function applyHeroSlide(el, dir, delay) {
    el.classList.add(dir === 'l' ? 'msk-hero-pre-l' : 'msk-hero-pre-r');
    el.style.setProperty('--msk-hd', delay + 'ms');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        el.classList.add('msk-hero-in');
        setTimeout(function () {
          el.classList.remove('msk-hero-pre-l', 'msk-hero-pre-r', 'msk-hero-in');
          el.style.removeProperty('--msk-hd');
        }, 1400 + delay);
      });
    });
  }

  function initHero() {
    if (window.__mskHeroDone) return;
    var found = 0;
    HERO_BLOCKS.forEach(function (cfg) {
      var el = document.querySelector('[id*="' + cfg.id + '"]') ||
               document.querySelector('[data-block-id*="' + cfg.id + '"]') ||
               document.querySelector('[class*="' + cfg.id + '"]');
      if (el) {
        found++;
        applyHeroSlide(el, cfg.dir, cfg.delay);
      }
    });
    if (found === 0) {
      /* fallback: grab first 3 visible block children of the hero _blocks section */
      var sec = document.getElementById('shopify-section-1762374876881db333');
      if (sec) {
        var children = Array.prototype.slice.call(
          sec.querySelectorAll('div[class], figure, article')
        ).filter(function (el) {
          var s = window.getComputedStyle(el);
          return s.display !== 'none' && el.offsetHeight > 0;
        }).slice(0, 3);
        var dirs = ['l', 'r', 'l'];
        children.forEach(function (el, i) {
          applyHeroSlide(el, dirs[i], i * 140);
        });
      }
    }
    window.__mskHeroDone = true;
  }

  function init() {
    prep(document);
    initHero();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType === 1) prep(n);
      }
    }
  });
  mo.observe(document.body || document.documentElement, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', function (e) { prep(e.target); });
})();